/* eslint-disable no-param-reassign */
import { withRangeCloneContentsPatched } from "./util/index.js";
/**
 * Enables Range.prototype.cloneContents monkey patch to improve pasting behavior
 * in few edge cases.
 */
export function withListsReact(editor) {
  var {
    setFragmentData
  } = editor;
  editor.setFragmentData = data => {
    withRangeCloneContentsPatched(function () {
      setFragmentData(data);
    });
  };
  return editor;
}